<template>
  <div>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent(-1)"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >新增</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-rules="rules"
      :edit-config="canEdit ? { trigger: 'click', mode: 'row' } : ''"
      :valid-config="{ autoPos: true, message: 'inline' }"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  export default {
    name: 'detailInfo',
    props: ['canEdit'],
    components: {
      // SearchTable,
      // InputNumber,
      // inputNumberAd,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 行号
            type: 'seq',
            width: 60,
            title: this.$t('table.index'),
          },
          {
            // 余额类型
            field: 'balanceType',
            title: this.$t('customerBalanceAdjust.table.balanceType'),
            editRender: {
              name: 'ElSelect',
              options: this.balanceTypeList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          /* { // 客户名称
          field: "partnerCode",
          title: this.$t('customerBalanceAdjust.table.partnerName'),
          editRender: { 
            name: "ElInput",
            props: {
              clearable: true,
              filterable: true
            },
          },
          slots: {
                default: ({ row }) => {
                  return [
                    <span>{ row.partnerName}</span>
                  ]
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="customer"
                      isMultiple={true}
                      currentValue={row['partnerName']}
                      checkRowKeys={[row['partnerCode']]}
                      onInput={val => this.chooseTable(val, row, 'partnerCode')}
                      extraData={
                        {
                          partnerTypes: "HZHB01,HZHB03",
                          requestStatus: "ZT03",
                        }
                      }
                    ></search-table>
                  ]
                }
              }
        }, */
          {
            // 调整额
            field: 'adjustAmount',
            title: this.$t('customerBalanceAdjust.table.adjustAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.adjustAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.adjustAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'adjustAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 备注
            field: 'remark',
            title: this.$t('customerBalanceAdjust.table.remark'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      rules() {
        return {
          balanceType: [
            {
              required: true,
              message: this.$t('customerBalanceAdjust.msg.balanceTypePlaceholder'),
            },
          ],
          /* partnerCode: [
          { required: true, message: this.$t('customerBalanceAdjust.msg.partnerNamePlaceholder') }
        ], */
          adjustAmount: [
            {
              required: true,
              message: this.$t('customerBalanceAdjust.msg.adjustAmountPlaceholder'),
            },
          ],
          remark: [
            { required: true, message: this.$t('customerBalanceAdjust.msg.remarkPlaceholder') },
          ],
        };
      },
    },
    data() {
      return {
        tableData: [],
        delDetailIds: [],
        baseData: {},
        balanceTypeList: this.$baseRequest
          .getDictListMapByType('balance_type')
          .filter((item) => item.value != '1'),
        addRowObj: {
          balanceType: null,
          //partnerCode: null,
          adjustAmount: 0,
          remark: null,
        },
      };
    },
    methods: {
      insertEvent(row) {
        // 表格新增一行
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt({ ...this.addRowObj }, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      handleDelete() {
        // 表格删除
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.delDetailIds.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancelled') });
          });
      },
      chooseTable(val, row, prop) {
        // 客户
        if (prop == 'partnerCode') {
          if (val && val.length > 0) {
            row.partnerCode = val[0].partnerCode;
            row.partnerName = val[0].partnerZhName;
            row.partnerType = val[0].partnerType;
          } else {
            row.partnerCode = null;
            row.partnerName = null;
            row.partnerType = null;
          }
        } else if (prop == 'adjustAmount') {
          row[prop] = val;
        }
      },
      exportChildData() {
        // 返回数据
        const [...tableData] = this.$refs.table.getTableData().fullData;
        if (tableData.length == 0) {
          return {
            delDetailIds: this.delDetailIds,
            detailList: [],
          };
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              let param = {
                delDetailIds: this.delDetailIds,
                detailList: tableData,
              };
              resolve(param);
            });
          });
        }
      },
    },
  };
</script>
